import { Hero } from './components/Hero';
import { FeaturedProducts } from './components/FeaturedProducts';
import { About } from './components/About';
import { Gallery } from './components/Gallery';
import { Location } from './components/Location';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <FeaturedProducts />
      <About />
      <Gallery />
      <Location />
      <Footer />
    </div>
  );
}